import { render, staticRenderFns } from "./ProjectTour.vue?vue&type=template&id=0b39efd6&scoped=true&"
import script from "./ProjectTour.vue?vue&type=script&lang=js&"
export * from "./ProjectTour.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTour.vue?vue&type=style&index=0&id=0b39efd6&lang=scss&scoped=true&"
import style1 from "./ProjectTour.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39efd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VImg})
